var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6630_4790)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6630_4790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.366 45.207C18.27 45.313 18.145 45.38 18 45.38C17.855 45.38 17.721 45.322 17.634 45.207C11.871 38.463 2 28.438 2 20C2 11.562 9.168 4 18 4C26.832 4 34 11.168 34 20C34 28.438 24.138 38.463 18.366 45.207Z",
    fill: "#BF3B2B"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0001 33.1415C25.2351 33.1415 31.1431 27.2345 31.1431 19.9985C31.1431 12.7625 25.2351 6.85547 18.0001 6.85547C10.7651 6.85547 4.85706 12.7535 4.85706 19.9985C4.85706 27.2335 10.7641 33.1415 18.0001 33.1415Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 14.3984H11.6C10.7163 14.3984 10 15.1148 10 15.9984V23.9984C10 24.8821 10.7163 25.5984 11.6 25.5984H24.4C25.2837 25.5984 26 24.8821 26 23.9984V15.9984C26 15.1148 25.2837 14.3984 24.4 14.3984Z",
    fill: "#FCBF49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 23C12.872 23 12.6 22.728 12.6 22.4V17.6C12.6 17.272 12.872 17 13.2 17C13.528 17 13.8 17.272 13.8 17.6V22.4C13.8 22.728 13.528 23 13.2 23Z",
    fill: "#E89236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 23C16.0719 23 15.7999 22.728 15.7999 22.4V17.6C15.7999 17.272 16.0719 17 16.3999 17C16.7279 17 16.9999 17.272 16.9999 17.6V22.4C16.9999 22.728 16.7279 23 16.3999 23Z",
    fill: "#E89236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6 23C19.272 23 19 22.728 19 22.4V17.6C19 17.272 19.272 17 19.6 17C19.928 17 20.2 17.272 20.2 17.6V22.4C20.2 22.728 19.928 23 19.6 23Z",
    fill: "#E89236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 23C22.472 23 22.2 22.728 22.2 22.4V17.6C22.2 17.272 22.472 17 22.8 17C23.128 17 23.4 17.272 23.4 17.6V22.4C23.4 22.728 23.128 23 22.8 23Z",
    fill: "#E89236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6630_4790",
    x: 0,
    y: 0,
    width: 36,
    height: 45.3789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6630_4790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6630_4790",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6630_4790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentLocation);
export default __webpack_public_path__ + "static/media/shipment_location.91c4d9b647362d6ea450458e7ee6bb50.svg";
export { ForwardRef as ReactComponent };